export default __webpack_public_path__ + "static/media/RentIcon.48e5296c.svg";